/* eslint-disable react/require-default-props -- defaults via destructuring; no defaultProps (React 19) */
import React from 'react';
import PropTypes from 'prop-types';

const FIRE_VIEWBOX = 18;

const FIRE_PATH =
  'M6.35085 6.2959L6.34916 6.29727L6.34756 6.29883L6.35085 6.2959ZM13.8164 6.156C13.7643 6.10571 13.7064 6.06171 13.6439 6.0249C13.5556 5.97289 13.4575 5.93956 13.3557 5.92698C13.254 5.91439 13.1507 5.9228 13.0524 5.9517C12.954 5.9806 12.8626 6.02938 12.7838 6.095C12.705 6.16063 12.6406 6.24172 12.5944 6.33325C12.336 6.84227 11.9797 7.29527 11.5459 7.66626C11.6122 7.29246 11.6457 6.91357 11.6459 6.53393C11.6472 5.379 11.3426 4.24433 10.7628 3.24545C10.1831 2.24657 9.34905 1.41914 8.34556 0.847428C8.23501 0.784763 8.11036 0.75121 7.9833 0.749917C7.85623 0.748624 7.73092 0.779632 7.61913 0.840034C7.50733 0.900436 7.41271 0.98825 7.34415 1.09524C7.27559 1.20222 7.23533 1.32487 7.22715 1.45168C7.18518 2.16281 6.99927 2.85802 6.68069 3.49518C6.36211 4.13234 5.91749 4.69819 5.37377 5.15845L5.20092 5.29908C4.63236 5.68164 4.12909 6.15325 3.71045 6.6958C3.05968 7.51563 2.60888 8.47581 2.39379 9.50018C2.1787 10.5246 2.20523 11.585 2.47129 12.5973C2.73735 13.6096 3.23562 14.5461 3.92657 15.3323C4.61753 16.1186 5.48217 16.733 6.45193 17.127C6.56579 17.1735 6.68936 17.1913 6.81172 17.1788C6.93408 17.1662 7.05149 17.1238 7.15358 17.0552C7.25566 16.9866 7.3393 16.8939 7.3971 16.7853C7.4549 16.6768 7.4851 16.5556 7.48502 16.4326C7.48449 16.3531 7.47189 16.274 7.44767 16.1982C7.27988 15.5675 7.23156 14.911 7.30521 14.2625C8.01489 15.601 9.15406 16.662 10.5396 17.2749C10.7087 17.3506 10.8999 17.3607 11.0761 17.3035C12.1708 16.9502 13.1569 16.3228 13.9408 15.481C14.7247 14.6392 15.2804 13.611 15.555 12.4939C15.8296 11.3769 15.814 10.2082 15.5097 9.09895C15.2054 7.98965 14.6225 6.97658 13.8164 6.156V6.156ZM10.8878 15.7793C10.2341 15.448 9.65737 14.9828 9.19521 14.4139C8.73305 13.8451 8.39578 13.1853 8.20535 12.4775C8.14719 12.2392 8.1022 11.9979 8.07058 11.7546C8.04916 11.5997 7.97986 11.4554 7.87237 11.3418C7.76489 11.2282 7.62459 11.151 7.4711 11.1211C7.42381 11.1118 7.37572 11.1071 7.32752 11.1072C7.19571 11.1071 7.0662 11.1418 6.95208 11.2078C6.83796 11.2738 6.74325 11.3687 6.6775 11.4829C6.0552 12.5563 5.74225 13.781 5.77332 15.0213C5.226 14.5957 4.76858 14.0658 4.42758 13.4621C4.08657 12.8585 3.86876 12.1932 3.78677 11.5048C3.70478 10.8164 3.76024 10.1185 3.94994 9.4517C4.13963 8.78487 4.45979 8.16232 4.89185 7.62014C5.21991 7.19401 5.61567 6.82461 6.06335 6.52664C6.08274 6.51413 6.10133 6.50043 6.11902 6.48562C6.11902 6.48562 6.34154 6.30151 6.34914 6.2973C7.41766 5.39352 8.17765 4.17893 8.5232 2.82278C9.34037 3.5782 9.88526 4.5823 10.0733 5.67916C10.2613 6.77602 10.0818 7.90426 9.56287 8.8887C9.4943 9.02006 9.46618 9.16878 9.48204 9.31611C9.4979 9.46344 9.55703 9.60277 9.65199 9.71653C9.74694 9.83029 9.87346 9.91338 10.0156 9.95532C10.1577 9.99726 10.3091 9.99618 10.4506 9.9522C11.5994 9.59207 12.6103 8.88863 13.3473 7.93657C13.7902 8.59079 14.0798 9.33653 14.1944 10.1182C14.3091 10.8999 14.2458 11.6974 14.0094 12.4512C13.773 13.2051 13.3695 13.8959 12.829 14.4721C12.2886 15.0483 11.625 15.4952 10.8878 15.7793L10.8878 15.7793Z';

const iconPropTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
  'aria-label': PropTypes.string,
  'aria-hidden': PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

/**
 * Fire / trending (18×18). Color via `fill` default `currentColor`.
 * Pass `aria-label` when the icon conveys meaning without adjacent text.
 */
const FireIcon = ({
  size = 18,
  fill = 'currentColor',
  className = '',
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden = true,
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox={`0 0 ${FIRE_VIEWBOX} ${FIRE_VIEWBOX}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={['ds-icon', className].filter(Boolean).join(' ')}
    aria-hidden={ariaLabel ? undefined : ariaHidden}
    aria-label={ariaLabel || undefined}
    role={ariaLabel ? 'img' : undefined}
    focusable="false"
    {...props}
  >
    <path d={FIRE_PATH} fill={fill} />
  </svg>
);

FireIcon.propTypes = {
  ...iconPropTypes,
  /** Any valid SVG fill; default inherits text/icon color. */
  fill: PropTypes.string,
};

export { FireIcon };
export default FireIcon;
